
import { Component, Input, OnInit } from '@angular/core';
import {
    LoadingController,
    NavController,
    NavParams,
    ToastController
} from 'ionic-angular';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { Sidepot } from '../../../../model/sidepot';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { ReportsService } from '../../../../services/reports.service';

@Component({
    selector: 'page-transactions-report',
    templateUrl: 'report-transactions.html'

})
export class TransactionReport implements OnInit {
    @Input('rodeo') rodeo: Rodeo
    @Input('viewMode') viewMode: string;

    report: { 
        report: {
            contestantOneName: string;
            contestantOneHorseName: string;
            contestantTwoName: string;
            contestantTwoHorseName: string;
            depositDate: string;
            depositReferenceId: string;
            email: string;
            // feeId: string;
            name: string;
            paymentId: string;
            productDescription: string;
            receiptId: string;
            rodeo: string;
            rodeoEvent: string;
            transactionDate: string;
            transferId: string;
            transferDate: string;
            totalChargedToCustomer: number;
            totalChargedByNextGen: number;
            totalReceivedBySecretary: number;
        }[],
        stripeReport: any
    };

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    constructor(private nav: NavController, private toast: ToastController, private navParams: NavParams, public api: ApiService, private reportService: ReportsService, private loadingControl: LoadingController) {
    }

    async ngOnInit() {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');

        this.printing = this.navParams.get('printing');

        let loading = this.loadingControl.create({
            content: 'Loading transactions...',
        });

        loading.present();
        try {
            this.report = await this.reportService.getTransactionReport(this.rodeo.id) as any;
            console.log(this.report);   
        } catch (err) {
            this.toast.create({ message: 'Something went wrong.', duration: 2500}).present();
        }
        this.dataLoaded = true;
        loading.dismiss();
    }

    download() {
        const report = this.report.report.map(x => {
            return {
                "Stripe Payment Id": x.paymentId,
                "Transaction Date": x.transactionDate,
                "Stripe Transfer Id": x.transferId,
                "Stripe Transfer Date": x.transferDate,
                "Customer Name": x.name,
                "Customer Email": x.email,
                "Rodeo": x.rodeo,
                "Rodeo Event": x.rodeoEvent,
                "Product Description": x.productDescription,
                "Contestant One Name": x.contestantOneName,
                "Contestant One Horse Name": x.contestantOneHorseName,
                "Contestant Two Name": x.contestantTwoName,
                "Contestant Two Horse Name": x.contestantTwoHorseName,
                "Total Charged To Customer": x.totalChargedToCustomer,
                "Total Charged By NextGen": x.totalChargedByNextGen,
                "Total Received By Secretary": x.totalReceivedBySecretary,
                "Deposit (Stripe Payout) Date": x.depositDate,
                "Deposit (Stripe Payout) Id": x.depositReferenceId, 
                "Receipt Url": x.receiptId,
            }
        });

        this.reportService.exportToCsv(report, `${this.rodeo.name}_Transactions`);
    }

    async downloadStripe() {
        await this.reportService.downloadStripePayoutCsv(this.report.stripeReport.id, this.rodeo.name);
    }

    load() {
        let index = 0;
        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.registrations.forEach((registration) => {
            });
        });

        this.documentTitle = this.rodeo.name + " - " + 'Entries';
        this.dataLoaded = true;
    }

    getSidepotCount(rodeoEvent: RodeoEvent, sidepot: Sidepot) {
        return rodeoEvent.registrations.filter(x => x.sidepotIds.some(y => y == sidepot.id)).length;
    }

    getOfficeFeeCount() {
        return new Set(this.rodeo.rodeoEvents.flatMap(x => x.registrations).flatMap(x => x.contestantOneId)).size;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(TransactionReport, {
            rodeo: this.rodeo,
            printing: true,
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-transactions.ts